import Effects from 'effects/Effects.js';
import {lstorage} from 'utils/lstorage.js';
import {isMobile} from 'react-device-detect';
import {uuid} from 'uuidv4';
import {findInstrumentPart, findEffect} from "utils/findEffect.js";
import {
    setBulkEffectsStarred,
    setBulkWindowPositions,
    setBulkEffectsCollapsed,
    setBulkModulesCollapsed,
    setWallpaper} from 'actions/index.js';
import {deleteAutomationsForParameters} from 'actions/index.js';
import {getTrackJson} from './json/getTrackJson.js';
import {loadSamplersIntoTrack} from './json/loadSamplersIntoTrack.js';
import {loadTrackJson, loadTrackPatternsAndEffects } from './json/loadTrackJson.js';
import startaudiocontext from 'startaudiocontext';
import Tone from 'tone';
import accounts from 'accounts/Accounts.js';
import LFO from 'modulators/LFO.js';
import SubSequence from './SubSequence.js';
import MidiEffectsChain from 'effects/midi/MidiEffectsChain.js';
import LiveEffectsChain from 'effects/live/LiveEffectsChain.js';
import {getDefaultEffects} from 'effects/getDefaultEffects.js';
import Crypto from 'crypto/Crypto.js';
import PlayableSequencerEngine from 'engine/PlayableSequencerEngine.js';
import EffectsChain from 'effects/EffectsChain.js';
import ParameterContext from 'effects/ParameterContext.js';
import ScriptableSequencer from 'engine/ScriptableSequencer.js';
import Sequence from 'repos/Sequence.js';
import Preset from 'repos/Preset.js';
import Sample from 'repos/Sample.js';
import Pattern from 'pattern/Pattern.js';
import StepData from 'pattern/StepData.js';
import StepBucket from 'pattern/StepBucket.js';
import Track from 'track/Track.js';
import MutableTrack from 'MutableTrack.js';
import MidiTrack from 'MidiTrack.js';
import AudioTrack from 'AudioTrack.js';
import InstrumentTrack from 'track/InstrumentTrack.js';
import MultiSynthTrack from 'track/MultiSynthTrack.js';
import FMSynthTrack from 'track/FMSynthTrack.js';
import SampledInstrumentTrack from 'track/SampledInstrumentTrack.js';
import MetalSynthTrack from 'track/MetalSynthTrack.js';
import Resolution from 'engine/Resolution.js';
import Sampler from 'instruments/Sampler.js';
import ParameterLocks from 'effects/ParameterLocks.js';
import ethereum from 'decentralized/ethereum.js';
import ContentKey from 'crypto/ContentKey.js';
import {getEffect} from 'effects/EffectsList.js';
import {
    setPulledEffects,
    setTrackBrowsedPresets,
    setEffectParameterValues,
    setNumberOfPatterns,
    setSequenceLoadingProgress,
       } from 'actions/index.js';
import {setSequenceName} from 'actions/index.js';
import {setLoadingSequence} from 'actions/index.js';
import {setPatternColor} from 'actions/index.js';
import {setAllEnvelopeLocks} from 'actions/index.js';
import {setAllLFOLocks} from 'actions/index.js';
import {setAllTrackPatternLocks} from 'actions/index.js';
import {setAllEffectPatternLocks} from 'actions/index.js';
import {setShowPasswordModal} from 'actions/index.js';
import {setPasswordModalCallback} from 'actions/index.js';
import {setSubSequences} from 'actions/index.js';
import ipfs from 'decentralized/Ipfs.js';
import {SAMPLER, MIDI, AUDIO, INSTRUMENT, INSTRUMENT_RACK} from 'constants/track-types.js';
import {loadParameterFromJson, saveParameterToJson} from 'parameters/parameterJsonFunctions.js';
import {getSampleIdsFromSequence, getSamples} from 'utils/getSamplesFromSequence.js';
import {
    SYNTH,
    EFFECTS,
    METAL_SYNTH,
    MULTI_SYNTH,
    FM_SYNTH,
    SAMPLED_INSTRUMENT,
    EXTERNAL_INSTRUMENT} from 'constants/instrument-types.js';
import Presets2 from 'decentralized/presets/Presets2.js';
import {constructTrack} from 'track/constructTrack.js';
import {PUBLIC, PRIVATE, GUILD} from 'constants/save-sequence-options.js';

const presets = ethereum.presets;

/**
 * A sub-class of SequencerEngine that can load and save
 * data to some backend (for now it's just the server
 * but in the future it could be IPFS and ethereum)
*/

class PersistentSequencer extends PlayableSequencerEngine {
    constructor(store, transport, aubio, stereoOnly, noMetronome, isOffline) {
        super(store, transport, aubio, stereoOnly, noMetronome, isOffline);

        this.recordingsToSave = [];
        this.loadedSequenceId = undefined;
        this.samplesToSync = [];
        //this.crypto.syncPassword();
        this.loadedSamples = {};

        this.editHistory = [];
    }  

    // saves the current sequence to the backend using
    // a name chosen by user via a prompt pop up
    save(name, saveOption, postToEthereum=true, selectedGuild) {
        let guildId = selectedGuild !== undefined && saveOption != PUBLIC ?
            selectedGuild.guildId :
            0;
        return new Promise(async (resolve, reject) => {
            let oldId = this.sequenceId;
            await this.saveAnyNewRecordings(guildId, postToEthereum);
            // create json with information like soundIds, tracksData
            var json = {
                hasPatterns: true,
                subSequences: this.getSubSequences(),
                sendVolumes: this.getSendVolumesToSave(),
                bpm: this.bpm,
                swing: this.swing,
                resolution: Track.baseResolution.toString(),
                tracksParameters: this.getTracksParametersToSave(),
                gateMode: this.gateMode,
                tracksPatterns: this.getTracksPatternsToSave(),
                scripting: this.scripting.getJson(),
                parameterLocks: this.parameterLocks.map(p => p.getJson()),
                effectsCollapsed: this.state.effects.effectCollapsed,
                modulesCollapsed: this.state.pads.modulesCollapsed,
                effectStarred: this.state.effects.effectStarred,
                mix: this.mix.getJson(),
                sends: this.sends.getJson(),
                patternColors: this.store.getState().toolbar.patternColors,
                lfos: this.lfos.map(lfo => lfo.getJson()),
                envelopes: this.envelopes.map(env => env.getJson()),
                lfoPatternLocks: this.state.tracks.lfoPatternLocks,
                envelopePatternLocks: this.state.tracks.envelopePatternLocks,
                effectPatternLocks: this.state.effects.effectPatternLocks,
                patternLocks: this.state.sequencer.patternLocks,
                trackPatternLocks: this.state.tracks.trackPatternLocks,
                scenes: this.scenes.getJson(),
                windowPositions: this.state.windows.windowPositions,
                pulledEffects: this.state.effects.pulledEffects.map(
                    e =>
                        e.type ?
                        {
                            x: e.x,
                            y: e.y,
                            width: e.width,
                            height: e.height,
                            id: e.id || e.instrument.id,
                            instrumentId: e.instrument.id,
                            type: e.type,
                            subType: e.subType
                        } : e.id),
                masterChannel: this.channelMixer.masterChannel.getJson(),
            };
            if (this.state.sequencer.wallpaper) {
                json.wallpaper = this.state.sequencer.wallpaper;
            }
            
            json = saveParameterToJson(json, 'bpmParameter', this.bpmParameter);
            json = saveParameterToJson(json, 'swingParameter', this.swingParameter);

            // get name of sequence
            // send the sequence to ethereum & ipfs
            let sequence = new Sequence(true);
            if (saveOption === PRIVATE) {
                ethereum.crypto.encryptAndSave(name, json, this.loadedSequenceId, postToEthereum)
                    .then(hash => {
                        this.update(hash);
                        resolve(hash);
                    });
            } else if (saveOption === GUILD) {
                ethereum.guildSequences.newGuildSequence(
                    json,
                    name,
                    this.loadedSequenceId,
                    selectedGuild.guildId)
                    .then(hash => {
                        this.update(hash);
                        resolve(hash);
                    });
            } else if (saveOption === PUBLIC){
                sequence.save(name, json, this.loadedSequenceId, this.getSamples(), postToEthereum)
                    .then(ret => {
                        this.update(ret.ipfsHash);
                        this.loadedSequenceId = ret.ipfsHash;
                        this.updateAutomationRedux(oldId, this.loadedSequenceId);
                        resolve(ret.ipfsHash);
                    });
            };
        });
    }

    getTrackMidiEffectsToSave() {
        let tracksMidiEffects = [];
        for (let i in this.tracks) {
            tracksMidiEffects.push(this.tracks[i].midiEffects.getJson());
        }

        return tracksMidiEffects;
    }

    getTrackLiveEffectsToSave() {
        let tracksLiveEffects = [];
        for (let i in this.tracks) {
            tracksLiveEffects.push(this.tracks[i].liveEffects.getJson());
        }

        return tracksLiveEffects;
    }

    // returns a json list of all the effects of
    // each track in the sequence
    getTrackEffectsToSave() {
        let tracksEffects = [];
        for (var i in this.tracks) {
            var trackEffects = [];
            let effects = this.tracks[i].effects;
            for (var j=0; j < effects.length; j++) {
                trackEffects.push(effects[j].getJson());
            }
            tracksEffects.push(trackEffects);
        }

        return tracksEffects;
    }

    getTrackEffectsChainsToSave() {
        let tracksChains = [];
        for (var i in this.tracks) {
            tracksChains.push(
                this.tracks[i].effectsChains.map(chain => chain.getJson()));
        }
        return tracksChains;
    }

    getSubSequences() {
        let subSequences = [];

        for (let j in this.subSequences) {
            this.switchToSubSequence(this.subSequences[j].id, false);
            let tracks = [];
            let tracksData = [];

            for (var i=0; i < this.subSequences[j].tracks.length; i++) {
                let track = this.subSequences[j].tracks[i];
                let {patterns, trackData} = getTrackJson(track);
                tracksData.push(trackData);
                tracks.push(patterns);
            }
            let groups = this.subSequences[j].groups.getJson();
            let lfos = this.subSequences[j]
                .lfosTrack
                .lfos
                .map(lfo => lfo.getJson());

            let envelopes = this.subSequences[j]
                .envelopesTrack
                .envelopes
                .map(env => env.getJson());

            subSequences.push({
                ... this.subSequences[j].getJson(),
                tracks: tracks,
                tracksData: tracksData,
                lfos: lfos,
                envelopes: envelopes,
                groups: groups,
                tracksPatterns: this.getTracksPatternsToSave(),
                tracksEffectsChains: this.getTrackEffectsChainsToSave(),
                tracksMidiEffects: this.getTrackMidiEffectsToSave(),
                tracksLiveEffects: this.getTrackLiveEffectsToSave(),
                tracksParameters: this.getTracksParametersToSave(),
                sendVolumes: this.getSendVolumesToSave(),
                mix: this.subSequences[j].mix.getJson(),
                id: this.subSequences[j].id,
                midiEffects: this.subSequences[j].midiEffects.getJson(),
                pads: this.subSequences[j].getPadsJson(),
                sequencers: this.subSequences[j].getSequencersJson()
            });
        }

        return subSequences;
    }

    getSendVolumesToSave() {
        return this.tracks
            .map(track =>
                 track.getSendNodes()
                     .map(send => send.volume.value));
    }

    getTracksPatternsToSave() {
        return this.tracks.map(
            track =>
                track.patterns.map((pattern) => pattern.getJson()));
    }

    // return the json representation of the trackData field for
    // each track
    getTracksParametersToSave() {
        return this.tracks.map((track) => track.trackData.getJson());
    }

    async loadSubSequences(data) {
        // first go through and initialize the array of tracks w/o loading
        // the patterns
        let subSequences = [];
        if (this.tracks.length === 0 && this.subSequences.length <= 1) {
            this.subSequences.forEach(s => s.dispose());
            this.subSequences = [];
        }

        for (let x in data.subSequences) {
            let subSequence = data.subSequences[x];
            let id = subSequence.id;
            let subSequenceObj = this.newSubSequence(id);
            let promises = subSequence.tracks.map(
                async (patterns, i) => {
                    return await loadTrackJson(this, subSequence.tracksData[i], patterns, i, subSequenceObj);
                });

            let tracks = await Promise.all(promises);
            
            for (let i in subSequence.tracksData) {
                let trackData = subSequence.tracksData[i];
                if ('chokes' in trackData) {
                    tracks[i].chokes.fromJson(trackData.chokes, tracks);
                }
            }
            tracks.forEach(
                track =>
                    subSequenceObj.addTrack(track));
            subSequenceObj.fromJson(subSequence);
            subSequences.push(subSequenceObj);
        }

        return subSequences;
    }

    getAllRecordingsToSave() {
        let recordingsToSave = this.recordingsToSave.filter(
            x => x.audioBuffer !== undefined);

        for (let i in this.subSequences) {
            let subSequence = this.subSequences[i];
            for (let j in subSequence.tracks) {
                recordingsToSave = [... recordingsToSave, ...subSequence.tracks[j].frozenSamplesToSave];
            }
        }

        return [...recordingsToSave, ... this.samplesToSync];
    }

    async saveAnyNewRecordings(guildId, postToEthereum=false) {
        // save any recordings recorded via midi tracks/audio tracks/resampling
        // during this session

        let recordingsToSave = this.recordingsToSave.filter(
            x => x.audioBuffer !== undefined);

        for (let i in this.subSequences) {
            let subSequence = this.subSequences[i];
            for (let j in subSequence.tracks) {
                if (guildId === 0 && postToEthereum && !window.installation) {
                    // dont make public anymore
                    // await subSequence.tracks[j].makePublicIfNeeded();
                }

                recordingsToSave = [... recordingsToSave, ...subSequence.tracks[j].frozenSamplesToSave];
            }
        }

        let contentKey = new ContentKey();
        let samples = [];
        for (let i in recordingsToSave) {
            let sample = recordingsToSave[i];
            let title = sample.name;
            let styles = ['', '', '', ''];
            let youtubeId = sample.videoId || '';
            let tags = sample.getTagsToSave();
            let year = new Date().getFullYear();
            if (tags.length > 4) {
                tags = tags.slice(0, 4);
            } 
            for (let i=tags.length; i < 4; i++) {
                tags.push('');
            }

            // todo: look up users country so we store where this was recorded
            let country = '';

            let sampleId = sample.getId();
            /*
            if (guildId !== 0) {
                // encrypt it
                let sound = await ipfs.getSound(sampleId);
                let newSampleId = await this.encryptedIpfs.addSound(
                    sound, GUILD, guildId, contentKey);
                this.replaceWithEncryptedSample(sampleId, newSampleId);
                sampleId = newSampleId;
            } 
            */

            if (sample.isResampled) {
                ethereum.resample.newResample(
                    sampleId, title, tags, sample.samplesUsed, guildId);
                continue;
            }

            samples.push({
                ipfsHash: sampleId,
                title: title,
                videoId: youtubeId,
                tags: tags,
                styles: styles,
                country: country,
                year: year,
                coverArt: undefined,
                discogsId: undefined,
            });
        }

        for (let i in this.samplesToSync) {
            let sample = this.samplesToSync[i];
            let title = sample.name;
            let styles = ['', '', '', ''];
            let youtubeId = sample.videoId || '';
            let tags = sample.tags;
            if (tags.length > 4) {
                tags.reverse();
                tags = tags.slice(0, 4);
            }

            for (let i=tags.length; i < 4; i++) {
                tags.push('');
            }
            let year = sample.year || 2020;

            let country = sample.country || '';

            let sampleId = sample.getId();


            /*
            if (guildId !== 0) {
                // encrypt it
                let sound = await ipfs.getSound(sampleId);
                sampleId = await this.encryptedIpfs.addSound(
                    sound, GUILD, guildId, contentKey);

                this.replaceWithEncryptedSample(sampleId);
            } 
            */


            samples.push({
                ipfsHash: sampleId,
                title: title,
                videoId: youtubeId,
                tags: tags,
                styles: styles,
                country: country,
                year: year,
                coverArt: sample.coverArtHash,
                discogsId: sample.discogsId,
            });
        }

        if (samples.length === 0) {
            return;
        }

        if (guildId !== 0) {
            ethereum.newEncryptedSamples(
                samples, guildId, contentKey);
        }  else {
            ethereum.newSamplesWithMetadata(
                samples, 0);
        }
    }

    loadTrackPatternLocks(data) {
        let locks = {... data.trackPatternLocks};
        if (data.tracks) {
            locks = {};
            locks[this.currentSubSequence.id] = data.trackPatternLocks;
        }

        locks = {
            ... this.state.tracks.trackPatternLocks,
            ... locks};

        console.log("locks to set =", locks);
        this.store.dispatch(setAllTrackPatternLocks(locks));
    }

    loadTrackMidiEffects(json, trackNumber, tracks) {
        if (json.tracksMidiEffects !== undefined) {
            let bulk = tracks[trackNumber].midiEffects.fromJson(json.tracksMidiEffects[trackNumber]);
            return {
                effects: tracks[trackNumber].midiEffects.effects,
                bulk
            };
        }
        return {effects: [], bulk: {}};
    }

    async loadTrackEffects(json, trackNumber, tracks) {
        var effects = [];
        let effectsChain = tracks[trackNumber].effectsChains[0];
        let bulk = {};
        if (json.tracksEffects !== undefined) {
            for (var j=0; j < json.tracksEffects[trackNumber].length; j++) {
                effects.push(await getEffect(
                    json.tracksEffects[trackNumber][j], tracks, this, trackNumber));
            }
            effectsChain.updateEffects(effects.map(x => x.effect));
        } else if (json.tracksEffectsChains !== undefined) {
            let track = tracks[trackNumber];
            let trackEffectsChains = json.tracksEffectsChains[trackNumber];
            let effectsChains = [];
            for (let j in trackEffectsChains) {
                let effectsChain = new EffectsChain(
                    track.gainNode, track.trackNode, new ParameterContext().forTrack(track), this);
                let effectsChainJson = trackEffectsChains[j];
                    
                for (let k in effectsChainJson) {
                    let effect = effectsChainJson[k];
                    let ret = await getEffect(effect, tracks, this, trackNumber);
                    effectsChain.addEffect(ret.effect);
                    bulk = {
                        ... bulk,
                        ... ret.bulk
                    };
                }
                effectsChain.updateEffects();
                effectsChains.push(effectsChain);
            }
            track.effectsChains.forEach(c => c.dispose());
            track.effectsChains = effectsChains;
        } else {
            effects = getDefaultEffects(this);
            effectsChain.updateEffects(effects);
        }
        
        return {effects, bulk};
    }

    loadSubSequenceMix(json, subSequence) {
        subSequence.mix.loadFromJson(json.mix, this);
    }
    
    sleep(time) {
        return new Promise(async (resolve, reject) => {
            setTimeout(() => resolve(), time);
        });
    }

    getSleepTime() {
        if (this.state.mix.isPlayingMix) {
            return 100;
        }
        return 0;
    }

    async loadSubSequencePatterns(json, subSequence, resolution, hasPatterns=true) {
        let bulk = {};
        let tracks = subSequence.tracks;
        for (var i=0; i < json.tracks.length; i++) {
            let track = tracks[i];
            await loadTrackPatternsAndEffects({
                sequencerEngine: this,
                track,
                tracks,
                patterns: json.tracks[i],
                trackData: json.tracksData[i],
                trackEffects: json.tracksEffects && json.tracksEffects[i],
                trackEffectChains: json.tracksEffectsChains && json.tracksEffectsChains[i],
                trackMidiEffects: json.tracksMidiEffects[i],
                patternParameters: json.tracksPatterns[i],
                subSequence
            });
        }
        return bulk;
    }

    loadSubSequenceTracksParameters(json, tracks) {
        for (var i in json.tracksParameters) {
            var trackData = json.tracksParameters[i];
            tracks[i].trackData.loadFromJson(trackData, undefined, false, false, this);
            tracks[i].pattern.calculateFills(trackData);
        }
    }

    loadSubSequencePatternParameters(json, tracks) {
        for (let i in tracks) {
            let track = tracks[i];
            for (var p=0; p < track.patterns.length; p++) {
                if (track.patterns.length > p) {
                    track.patterns[p].loadFromJson(json.tracksPatterns[i][p]);
                }
            }
        }
    }

    loadSubSequenceEffects(json, tracks) {
        for (let i in tracks) {
            let track = tracks[i];
            this.setupNewTrack(track, true, true, false);
            let sendNodes = track.getSendNodes();
            for (let sendNumber=0; sendNumber < json.sendVolumes[i].length; sendNumber++) {
                if (sendNodes[sendNumber]) {
                    sendNodes[sendNumber].volume.value = json.sendVolumes[i][sendNumber];
                }
            }
            
            if (json.tracksLiveEffects !== undefined) {
                track.liveEffects.fromJson(json.tracksLiveEffects[i]);
            }
        }

        if (json.midiEffects) {
            let ret = this.currentSubSequence.midiEffects.fromJson(json.midiEffects);
            this.dispatch(
                setEffectParameterValues(ret));
        }
    }

    getMaxSubSequenceId() {
        let max = -1;
        for (let i in this.subSequences) {
            let id = this.subSequences[i].id;
            if (id > max) {
                max = id;
            }
        }
        return max;
    }

    loadSubSequenceLFOs(json, subSequence) {
        let bulk = {};
        for (let i in json.lfos) {
            let lfo = json.lfos[i];
            bulk = {
                ... bulk,
                ... subSequence.lfos[parseInt(i)].lfo.fromJson(lfo)
            };
        }
        return bulk;
    }

    loadSubSequenceEnvelopes(json, subSequence) {
        for (let i in json.envelopes) {
            let envelope = json.envelopes[i];
            subSequence.envelopes[parseInt(i)].fromJson(envelope);
        }
    }

    normalizeSubSequenceIds(json) {
        let fromToMapping = {};
        for (let i in json.subSequences) {
            let id = json.subSequences[i].id;
            if (isNumber(id)) {
                fromToMapping[id] = uuid();
            } else {
                fromToMapping[id] = id;
            }
        }
        this.convertSubSequenceIds(json, fromToMapping);
    }

    convertSubSequenceIds(json, fromToMapping) {
        for (let i in json.subSequences) {
            let subSequence = json.subSequences[i];
            if (fromToMapping[subSequence.id] !== undefined) {
                subSequence.id = fromToMapping[subSequence.id];
            }

            json.subSequences[i] = subSequence;
        }

        let trackPatternLocks = {};
        let lfoPatternLocks = {};
        let envelopePatternLocks = {};

        let values = new Set(Object.values(fromToMapping));
        for (let id in json.trackPatternLocks) {
            // id = parseInt(id);
            if (fromToMapping[id] !== undefined) {
                let to = fromToMapping[id];
                trackPatternLocks[to] = json.trackPatternLocks[id];
            } else if (!values.has(id)) {
                trackPatternLocks[id] = json.trackPatternLocks[id];
            }
        }

        for (let id in json.envelopePatternLocks) {
            if (fromToMapping[id] !== undefined) {
                let to = fromToMapping[id];
                envelopePatternLocks[to] = json.envelopePatternLocks[id];
            } else if (!values.has(id)) {
                envelopePatternLocks[id] = json.envelopePatternLocks[id];
            }
        }

        for (let id in json.lfoPatternLocks) {
            if (fromToMapping[id] !== undefined) {
                let to = fromToMapping[id];
                lfoPatternLocks[to] = json.lfoPatternLocks[id];
            } else if (!values.has(id)) {
                lfoPatternLocks[id] = json.lfoPatternLocks[id];
            }
        }

        json.trackPatternLocks = trackPatternLocks;
        json.lfoPatternLocks = lfoPatternLocks;
        json.envelopePatternLocks = envelopePatternLocks;
    }

    // loads a sequence from the given ipfs hash (the id)
    loadSequence(id) {

        this.setLoadingProgress(id, 0);
        return new Promise(async (resolve, reject) => {
            this.store.dispatch(setLoadingSequence(id, true));
            // first check if it's been shared with you (via encryption)
            let user = await accounts.getAccount();
            let decryptedData = undefined;

            try {
                if (!window.isNFT && lstorage.getItem("sequence." + id)) {
                    decryptedData = lstorage.getItem("sequence." + id);
                } else if (user !== undefined) {
                    let sequence = await ethereum.guildSequences.getGuildSequence(id);
                    if (sequence === undefined) {
                        sequence = await ethereum.encryption.getSequencesSharedWithUser(id);
                        sequence = sequence[0];
                    }
                    if (sequence !== undefined) {
                        decryptedData = await ethereum.crypto.fetchAndDecrypt(id, sequence);
                    } else {
                        // otherwise check if it's encrypted by you, personally
                        let encrypted = await ethereum.encryption.getEncryptedSequenceIfAny(id);
                        if (encrypted !== undefined) {
                            decryptedData = await ethereum.crypto.fetchAndDecrypt(id, encrypted);
                        } 
                    }
                } 
            } catch (e) {
            }

            let first = false;
            if (this.tracks.length == 0) {
                first = true;
            }
            
            // Tone.context.latencyHint = 'playback';
            let sequence = new Sequence(
                !isNumber(id), isNumber(id) ? id : undefined, !isNumber(id) ? id : undefined, decryptedData);
            
            sequence.loadTitle()
                .then(title => {
                    this.store.dispatch(setSequenceName(title));
                });
            
            sequence.load()
                .then(async (data) => {
                    this.loadedSequenceId = id;
                    console.log({...data});
                    console.log(this);

                    this._wallpaper = data.wallpaper;
                    if (data.wallpaper && (window.exhibit || !window.explore || isMobile)) {
                        this.dispatch(setWallpaper(data.wallpaper));
                    }

                    // first load the samples
                    let sampleIds = getSampleIdsFromSequence(data);
                    // this.loadedSamples = await getSamples(sampleIds, this.encryptedIpfs, this.getSleepTime());
                    this.setLoadingProgress(id, 25);

                    this.normalizeSubSequenceIds(data);
                    var maxLength = this.length;
                    var resolution = Track.oldDefaultResolution;
                    
                    let groups = data.groups;

                    if (!this.hasAtleastOneSequencerEnginePlaying()) {
                        this.updateBpm(data.bpm);
                        loadParameterFromJson(data, 'bpmParameter', this.bpmParameter);
                    }

                    if (data.subSequences === undefined) {
                        data.subSequences = [{
                            id: 0,
                            tracks: data.tracks,
                            tracksData: data.tracksData,
                            groups: data.groups,
                            envelopes: data.envelopes,
                            lfos: data.lfos,
                            tracksParameters: data.tracksParameters,
                            tracksPatterns: data.tracksPatterns,
                            tracksEffects: data.tracksEffects,
                            tracksMidiEffects: data.tracksMidiEffects,
                            tracksLiveEffects: data.tracksLiveEffects,
                            sendVolumes: data.sendVolumes,
                        }];

                        let trackPatternLocks = {};
                        for (let i in data.tracksData) {
                            let trackData = data.tracksData[i];
                            trackPatternLocks[i] = trackData.patternLocks;
                        }

                        data.trackPatternLocks = trackPatternLocks;
                    }

                    this.normalizeSubSequenceIds(data);

                    if ('swing' in data) {
                        this.updateSwing(data.swing);
                        loadParameterFromJson(data, 'swingParameter', this.swingParameter);
                    }

                    resolution = getResolution(data.resolution);
                    
                    var hasPatterns = false;
                    if ('hasPatterns' in data) {
                        hasPatterns = true;
                    }


                    if (first) {
                        this.playSequence = this.getPlaySequence();
                    }
		    
                    let subSequences = await this.loadSubSequences(data);
                    this.loadTrackPatternLocks(data);

                    if ('sends' in data) {
                        await this.sends.loadFromJson(data.sends);
                    }

                    console.log("sends inited");

                    this.setLoadingProgress(id, 35);
                    let bulk = {};
                    for (let i in subSequences) {
                        this.setLoadingProgress(id, 35 + 35 * ( parseFloat(i) / subSequences.length));
                        let dateA = new Date().getTime();
                        this.switchToSubSequence(subSequences[i].id, false);
                        console.log("loading subsequence patterns");
                        bulk = {
                            ... bulk,
                            ... await this.loadSubSequencePatterns(
                                data.subSequences[i],
                                subSequences[i],
                                resolution,
                                hasPatterns)
                        };
                        console.log("loading track params");
                        this.loadSubSequenceTracksParameters(
                            data.subSequences[i], subSequences[i].tracks);
                        console.log("loading track effects");
                        this.loadSubSequenceEffects(
                            data.subSequences[i], subSequences[i].tracks);
                        bulk = {
                            ... bulk,
                            ... this.loadSubSequenceLFOs(
                                data.subSequences[i], subSequences[i])
                        };
                        this.loadSubSequenceEnvelopes(
                            data.subSequences[i], subSequences[i]);
                        this.loadSubSequenceMix(
                            data.subSequences[i], subSequences[i]);
                        subSequences[i].loadPadsJson(data.subSequences[i].pads);
                        subSequences[i].loadSequencersJson(data.subSequences[i].sequencers);
                    }
                    this.switchToSubSequence(subSequences[0].id, false);

                    this.store.dispatch(setEffectParameterValues(bulk));
                    console.log("loading effect pattern locks");

                    if ('effectPatternLocks' in data) {
                        this.dispatch(
                            setAllEffectPatternLocks(data.effectPatternLocks));
                    }

                    if ('lfoPatternLocks' in data) {
                        let locks = {... data.lfoPatternLocks};
                        if (data.tracks) {
                            locks = {};
                            locks[this.currentSubSequence.id] =  data.lfoPatternLocks;
                        }
                        locks = {
                            ... this.state.tracks.lfoPatternLocks,
                            ...locks
                        };
                        this.store.dispatch(setAllLFOLocks(locks));
                    }

                    this.setLoadingProgress(id, 80);
                    if ('envelopePatternLocks' in data) {
                        let locks = {... data.envelopePatternLocks};
                        if (data.tracks) {
                            locks = {};
                            locks[this.currentSubSequence.id] = data.envelopePatternLocks;
                        }
                        locks = {
                            ... this.state.tracks.envelopePatternLocks,
                            ...locks,
                        };
                        this.store.dispatch(setAllEnvelopeLocks(locks));
                    }
                    
                    if ('gateMode' in data) {
                        this.gateMode = data.gateMode;
                    } else {
                        this.gateMode = true;
                    }
                    
                    
                    for (let i in subSequences) {
                        this.switchToSubSequence(subSequences[i].id, false);
                        await subSequences[i].groups.fromJson(
                            data.subSequences[i].groups, this);
                    }
                    
                    this.setLoadingProgress(id, 90);

                    if ('mix' in data) {
                        this.mix.loadFromJson(data.mix, this);
                    }

                    this.loadParameterLocks(data);

                    await this.sleep(this.getSleepTime());
                        
                    this.setLoadingProgress(id, 95);
                    for (let i in subSequences) {
                        let subSequence = subSequences[i];
                        for (let j in subSequence.tracks) {
                            let track = subSequence.tracks[j];
                            if (track.group === undefined) {
                                if (track.getTrackType() === 'MIDI') {
                                    subSequence.groups.addMidiTrack(track);
                                } else {
                                    if (track.sample !== undefined &&
                                        track.sample.ipfsHash !== undefined) {
                                        subSequence.groups.addTrack(track);
                                    }
                                }
                            };
                            // check if any of these tracks contain lost parameters

                            // load any pulled effects
                            this.loadPulledEffects(data.pulledEffects);
                       }
                    }

                    for (let subSequence of subSequences) {
                        for (let track of subSequence.tracks) {
                            setTimeout(() => {
                                track.loadLostParameters();
                                for (let p of track.patterns) {
                                    p.getAllSteps().forEach(
                                        p => p.loadParameterLocks());
                                }
                                track.updateSteps();
                            }, 750);
                        }
                    }

                    if ('masterChannel' in data) {
                        this.channelMixer.masterChannel.fromJson(data.masterChannel);
                    }
                    if ('patternColors' in data) {
                        for (let i in data.patternColors) {
                            this.store.dispatch(setPatternColor(parseInt(i), data.patternColors[i]));
                        }
                    }

                    if ('scenes' in data) {
                        this.scenes.fromJson(data.scenes);
                    }

                    if ('effectsCollapsed' in data) {
                        this.dispatch(
                            setBulkEffectsCollapsed(data.effectsCollapsed));
                    }
                    if ('effectStarred' in data) {
                        this.dispatch(
                            setBulkEffectsStarred(data.effectStarred));
                    }
                    if ('modulesCollapsed' in data) {
                        this.dispatch(
                            setBulkModulesCollapsed(data.modulesCollapsed));
                    }
                    if ('windowPositions' in data) {
                        this.dispatch(
                            setBulkWindowPositions(data.windowPositions));
                    }

                    // basically trick the LFO into starting correctly by
                    // playing and stopping it (i know, stupid hack but fuck)
                    this.play();
                    this.play();
                    this.updateTracks();
                    this.sends.sends.forEach(s => s.hookupPads());

                    for (let i=subSequences.length - 1; i >= 0; i--) {
                        this.switchToSubSequence(subSequences[i].id, true);
                        for (let track of this.tracks) {
                            track.midiEffects.setupMessageReader();
                        }
                    }

                    
                    // Tone.context.latencyHint = this.latencyHint || 'interactive';
                    this.store.dispatch(setNumberOfPatterns(this.numberOfPatterns()));
                    if (this.update !== undefined) {
                        this.update(id);
                    }


                    this.selectTrack(0);
                    this.setLoadingProgress(id, 100);
                    this.store.dispatch(setLoadingSequence(id, false));
                    resolve();
                });
        });
    }

    newNumberOfPatterns(num) {
        for (let i=this.numberOfPatterns(); i < num; i++) {
            this.newPattern(true);
        }
    }

    combineWithSequencerEngine(toCombine) {
        for (let i in toCombine.subSequences) {
            let subSequence = toCombine.subSequences[i];
            if (this.getSubSequence(subSequence.id) !== undefined) {
                // need to get an id that hasn't been used 
                let max = -1;
                for (let j in this.subSequences) {
                    let id = this.subSequences[j].id;
                    if (id > max) {
                        max = id;
                    }
                }
                subSequence.id = max + 1;
                this.addSubSequence(subSequence);
            }
        }
    }

    loadParameterLocks(data) {
        if ('parameterLocks' in data) {
            let parameterLocksJson = data.parameterLocks;
            this.parameterLocks = [];
            for (let i in parameterLocksJson) {
                let parameterLocks = new ParameterLocks();
                parameterLocks.fromJson(parameterLocksJson[i], this);
                this.parameterLocks.push(parameterLocks);
            }
            
            while (this.parameterLocks.length < 2) {
                this.parameterLocks.push(new ParameterLocks());
            }
        }
    }
   
    loadSlices(data, trackNumber) {
        var slices = [];
        if ('samplersParameters' in data) {
            if (Array.isArray(data.samplersParameters[trackNumber])) {
                slices = data.samplersParameters[trackNumber];
            } else {
                slices.push({
                    startTime : data.samplersParameters[trackNumber].startTime,
                    endTime : data.samplersParameters[trackNumber].endTime
                });
            }
        }
        return slices;
    }

    newRecordingToSaveLater(sample) {
        this.recordingsToSave.push(sample);
    }

    getParameterFromJson(json) {
        let contextJson = json.context;
        let context = new ParameterContext();
        let track = undefined

        let effects = [];
        if (contextJson.track !== undefined) {
            let chainNumber = 0;
            if (contextJson.chainNumber !== undefined) {
                chainNumber = contextJson.effectsChainNumber;
            }
            track = this.tracks[contextJson.track];
            effects = track.effectsChains[chainNumber].effects;
            context = context.forTrack(track);
        } else if (contextJson.group !== undefined) {
            let group = this.groups.groups[contextJson.group];
            effects = group.effects;
            context = context.forGroup(group);
        } else if (contextJson.sends !== undefined) {
            let send = this.sends.sends[contextJson.sends];
            effects = send.effects;
            context = context.forSend(send);
        }

        let parameters = undefined 
        if (contextJson.isInstrument) {
            parameters = track.instrument.parameters;
        } else if (contextJson.effect !== undefined && contextJson.effect != -1) {
            let effect = effects[contextJson.effect];
            parameters = effect.parameters;
        } else if (track !== undefined) {
            parameters = track.trackData.parameters;
        }

        if (parameters !== undefined) {
            let parameterName = json.name;

            // find the paramter within the parameters
            let matchingParameters = parameters.filter(
                parameter => parameter.name === parameterName);
            
            if (matchingParameters.length >= 1) {
                return matchingParameters[0];
            }
        }

        // todo figure out track parameters
        return undefined;
    }

    async getEffectsPreset(data, track) {
        let ret = {};
        let bulk = {};
        if (data.effectsChains) {
            data.trackEffectsChains = data.effectsChains;
        }
        if (data.trackEffectsChains) {
            let effectsChains = [];
            for (let i in data.trackEffectsChains) {
                let effectsChain = new EffectsChain(
                    track.gainNode, track.trackNode, new ParameterContext().forTrack(track), this);
                let effectsChainJson = data.trackEffectsChains[i];
                effectsChain.initDefault();
                
                for (let j in effectsChainJson) {
                    let effect = effectsChainJson[j];
                    let r = await getEffect(effect, this.tracks, this, i);
                    bulk = {
                        ... bulk,
                        ... r.bulk
                    };
                    effectsChain.addEffect(r.effect);
                }
                effectsChains.push(effectsChain);
            }
            ret.effectsChains = effectsChains;
        }
        
        if (data.midiEffects) {
            ret.midiEffects = new MidiEffectsChain(track);
            bulk = {
                ... bulk,
                ... ret.midiEffects.fromJson(data.midiEffects)
            };
        }

        this.store.dispatch(setEffectParameterValues(bulk));

        return ret;
    }

    async loadEffectsPreset(
        data,
        loadLFOsAndEnvelopes,
        track=this.tracks[this.store.getState().cursor.track])
    {
        if (loadLFOsAndEnvelopes) {
            this.loadLFOsAndEnvelopes(data);
        }

        let ret = await this.getEffectsPreset(data, track);
        if (ret.effectsChains) {
            track.effectsChains = ret.effectsChains;
        }
        if (ret.midiEffects) {
            track.midiEffects = ret.midiEffects;
        }

        if (data.liveEffects) {
            track.liveEffects  = new LiveEffectsChain(track);
            track.liveEffects.fromJson(data.liveEffects);
        }
    }

    async auditionPreset(preset, trackNumber, loadMods=true, loadEffects=false, load=true) {
        let presetName = preset.title;
        let data = !load ? preset.data : await presets.getPresetData(preset);
        let track = this.tracks[trackNumber];
        if (track.tracks && data.trackParameters.type !== INSTRUMENT_RACK) {
            track = this.state.tracks.selectedRackSubTrack[track.id] ||
                track.tracks[0];
            track = track.track;
        } else if (track.tracks) {
            // so we're auditioning a rack with another rack, so we must clear
            // each rack
            let tracks = [...track.tracks];
            tracks.forEach(
                subTrack => track.deleteInstrument(subTrack));
        }
        let bulk = {};
        if (loadMods) {
            bulk = this.loadLFOsAndEnvelopes(data);
        }
        track.preset = new Preset(preset.title, preset.contentHash, preset.user, preset.blockNumber);
        track.preset.track = track;
        track.preset.data = data;
        track.preset.tags = preset.tags;
        track.presetName = presetName;
        track.preset.name  = presetName;

        track.getAllParameters().forEach(
            p => p.unmap());

        track.liveEffects.clearEffects();

        let vol = track.volumeParameter.get();
        bulk = {
            ...bulk,
            ...await track.fromJson(data.trackParameters, undefined, false, false, true, true)
        };
        track.setVolume(vol);
        let parameters = track.getAllParameters();
        let automationParameters = parameters
            .filter(x => x.automations && x.automations.length > 0);
        this.store.dispatch(
            deleteAutomationsForParameters(automationParameters));
        
        if (loadEffects) {
            track.effectsChains.forEach(e => e.clear());
        }
        track.midiEffects.clear();
        track.midiEffects.effects.forEach(e => e.dispose());
        track.midiEffects.effects = [];
        track.preset.hasEdits = false;
        track.presetName = presetName;

        // check if any of these tracks contain lost parameters
        //setTimeout(async () => {
           // waiting 750 ms so that parameters that might require a timeout
            // have loaded in time
        bulk = {
            ... bulk,
            ... await this.loadPresetEffects(track, data, !loadEffects)
        };
        track.loadLostParameters();
        track.setIsEnabled(track.isEnabled);
        this.store.dispatch(setEffectParameterValues(bulk));
        this.update();
        track.preset.loadMods = loadMods;
        track.preset.loadEffects = loadEffects;
        this.addPresetToBrowsedPresets(track, track.preset);
        this.loadedProject = true;
    }

    addPresetToBrowsedPresets(track, preset) {
        let browsedPresets = this.state.tracks.trackBrowsedPresets[track.id] || [];
        if (browsedPresets.some(p => p.contentHash === preset.contentHash) ) {
            // no need to update list since its already in it
            return;
        }

        let presets =
            [
                preset,
                ... (browsedPresets.filter(s => s.ipfsHash !== preset.ipfsHash))
            ];

        this.store.dispatch(setTrackBrowsedPresets(track.id, presets));
    }

    // loads a preset into the project
    // loadLFOs tells us whether we should load the LFOs and thus, replace
    // any existing settings inside the project's LFOs
    async loadPreset(preset, loadLFOs) {
        let presetId = preset.contentHash;
        let presetName = preset.title;
        if (presetId === undefined && typeof preset === 'string') {
            presetId = preset;
        }
        let data = await presets.getPresetData(preset);
        let instrumentType = await presets.getPresetInstrumentType(presetId);
        if (instrumentType === EFFECTS) {
            this.loadEffectsPreset(data, loadLFOs);
            return;
        }
        if (data.tracks === undefined) {
            await this.loadTrackPreset(data, presetId, loadLFOs, undefined, presetName, undefined, preset);
            // set the name now...
            this.tracks[this.tracks.length - 1].presetName = presetName;
            return;
        }

        let trackToNumber = {};
        for (let trackNumber in data.tracks) {
            trackToNumber[trackNumber] = this.tracks.length;
            this.loadTrackPreset(data.tracks[trackNumber], undefined, loadLFOs);
        }

        if (data.keyMappings) {
            for (let key in data.keyMappings) {
                let mapping = data.keyMappings[key];
                let trackNumber = trackToNumber[mapping.trackNumber];
                this.keyboardEngine.map(mapping.key, trackNumber, mapping.sliceNumber);
            }
        }
    }

    loadLFOsAndEnvelopes(data) {
        let bulk = {};
        if ('lfos' in data) {
            for (let i in data.lfos) {
                let lfo = data.lfos[i];
                // this.lfos[parseInt(i)].lfo.disconnectAllModulators();
                bulk = {
                    ... bulk,
                    ... this.lfos[parseInt(i)].lfo.fromJson(lfo)
                };
            }

        }
        
        if ('envelopes' in data) {
            for (let i in data.envelopes) {
                let envelope = data.envelopes[i];
                bulk = {
                    ... bulk,
                    ... this.envelopes[parseInt(i)].fromJson(envelope)
                };
            }
        }
        return bulk;
    }

    async loadPresetAsSubSequence(preset, data) {
        let presetId = preset.contentHash;
        let presetName = preset.name;
        if (presetId === undefined && typeof preset === 'string') {
            presetId = preset;
        }
        if (data === undefined) {
            data = await presets.getPresetData(preset);
        }
        let track = await this.loadTrackPreset(data, presetId, false, false, presetName, 1, preset);
        let subSequence = this.newSubSequence(undefined, track);
        this.loadLFOsAndEnvelopes(data);
        track.trackNumber = 0;
        track.updateSteps();
    }

    // load an individual track preset
    async loadTrackPreset(data, presetId, loadLFOsAndEnvelopes, addToProject=true, presetName, numberOfPatterns=this.numberOfPatterns(), presetBlockData) {
        if (loadLFOsAndEnvelopes) {
            this.loadLFOsAndEnvelopes(data);
        }

        let track = undefined;
        if (data.trackParameters.type === MIDI) {
            track = new MidiTrack(
                this.tracks.length,
                this,
                this.mixSession,
                numberOfPatterns,
                () => this.update(),
                this.currentSubSequence);

            await loadSamplersIntoTrack(
                track,
                data.trackParameters,
                this.currentSubSequence);
            track.setMidiEngine(this.midi);
            this.setupRecordableTrack(track);
        } else if (data.trackParameters.type === INSTRUMENT ||
                  data.trackParameters.type === INSTRUMENT_RACK) {
            // instrument type: SYNTH OR MULTI_SYNTH OR EXTERNAL_INSTRUMENT?
            let instrumentType = data.trackParameters.instrumentType;
            track = constructTrack(
                this,
                data.trackParameters.type,
                instrumentType,
                numberOfPatterns,
            );
        }  else {
            track = new MutableTrack(
                this.tracks.length,
                this,
                this.mixSession,
                numberOfPatterns,
                () => this.update(),
                this.sends);
            await loadSamplersIntoTrack(
                track,
                data.trackParameters,
                this.currentSubSequence);
        }
            // TODO: add to group!!
 
        track.setSends(this.sends);
        await track.fromJson(data.trackParameters, undefined, undefined, undefined, true);

        track.trackData.loadFromJson(data.trackData, undefined, false, false, this);
        
        // load track parameters like "muted" and "gated"

        this.loadPresetEffects(track, data);

            track.gated = data.trackParameters.gated;

        // track.updateEffects();
        
        if (addToProject) {
            this.setupNewTrack(track, true, true);
            this.groups.addTrack(track);
            
            if ('sendVolumes' in data) {
                let sendNodes = track.getSendNodes();
                for (let sendNumber=0; sendNumber < data.sendVolumes.length; sendNumber++) {
                    if (sendNodes[sendNumber]) {
                        sendNodes[sendNumber].volume.value = data.sendVolumes[sendNumber];
                    }
                }
            }
            this.currentSubSequence.addTrack(track);
            track.switchToPattern(this.currentPattern);
            track.updateSteps();
            this.update();
        }

        track.presetId = presetId;
        track.presetName = presetName;
        if (presetBlockData) {
            track.preset = new Preset(presetName, presetId, presetBlockData.user, presetBlockData.blockNumber);
            track.preset.load();
            track.preset.track = track;
        }

        // check if any of these tracks contain lost parameters
        setTimeout(() => {
           // waiting 750 ms so that parameters that might require a timeout
            // have loaded in time
            track.loadLostParameters();
        }, 750);

        return track;
    }

    async loadPresetEffects(track, data, skipAudioFx=false) {
        let bulk = {};
        if (!skipAudioFx) {
            if (data.trackEffects) {
                let effects = [];
                for (var i=0; i < data.trackEffects.length; i++) {
                    let ret = await getEffect(data.trackEffects[i], this.tracks, this);
                    effects.push(ret.effect);
                }
                track.effectsChains[0].effects = effects;
            } else if (data.trackEffectsChains) {
                let effectsChains = [];
                for (let i in data.trackEffectsChains) {
                    let effectsChain = new EffectsChain(
                        track.gainNode, track.trackNode, new ParameterContext().forTrack(track), this);
                    let effectsChainJson = data.trackEffectsChains[i];
                    
                    for (let j in effectsChainJson) {
                        let effect = effectsChainJson[j];
                        let ret = await getEffect(effect, this.tracks, this, i);
                        bulk = {
                            ... bulk,
                            ... ret.bulk
                        };
                        effectsChain.addEffect(ret.effect);
                    }
                    effectsChain.updateEffects();
                    effectsChains.push(effectsChain);
                }
                track.effectsChains.forEach(chain => chain.dispose());
                track.effectsChains = effectsChains;
            }
        }
        
        if (data.midiEffects) {
            bulk = {
                ... bulk,
                ... track.midiEffects.fromJson(data.midiEffects)
            };
        }

        
        if (data.liveEffects) {
            track.liveEffects.fromJson(data.liveEffects);
        }
        return bulk;
    }

    saveProjectAsPreset() {
        let tracks = [];
        for (let trackNumber in this.tracks) {
            let trackPreset = this.getTrackPreset(trackNumber);
            tracks.push(trackPreset);
        }

        let lfos = undefined;
        if (tracks.length > 0) {
            lfos = tracks[0].lfos;
        }

        let keyMappings = this.keyboardEngine.keyMappings;
        let midiMappings = this.keyboardEngine.midiMappings;

        let json = {
            lfos: lfos,
            tracks: tracks,
            keyMappings: keyMappings,
            midiMappings: midiMappings,
        };

        let name = window.prompt('Type name of preset');
        presets.newPreset(json, name)
            .catch(err => {
                console.log(err);
            })
            .then((presetId) => {
                this.presetId = presetId;
            });;
    }

    saveTrackPreset(trackNumber, name, isEffects, guildId, previousHash) {
        return new Promise(async (resolve, reject) => {
            let track = this.tracks[trackNumber];
            if (guildId == 0) {
                await track.makePublicIfNeeded();
            }
            let json = isEffects ? this.getEffectPreset(trackNumber) : this.getTrackPreset(trackNumber);
            let instrumentType = isEffects ? EFFECTS : track.getInstrumentType();
            if (track.tracks) {
                instrumentType = INSTRUMENT_RACK;
            }
            let sampleHash = undefined;
            if (track.sample !== undefined && !isEffects) {
                sampleHash = track.sample.getId();
            }

            presets.newPreset(json, name, sampleHash, instrumentType, guildId)
                .catch(err => {
                    console.log(err);
                })
                .then(async (presetId) => {
                    track.presetId = presetId;

                    if (track.resampledFrom && track.resampledFrom.contentHash) {
                        // then we need to savea
                        await ethereum.xanadu.presetResampled(
                            track.resampledFrom.contentHash, presetId);
                    }

                    // the contentHash => tag
                    if (instrumentType === EXTERNAL_INSTRUMENT) {
                        let midiInterface = track.midiEffects.effects.filter(
                            effect => effect.name === 'Midi Interface')[0];

                        if (midiInterface !== undefined) {
                            let output = midiInterface.midiOutput.name;
                            presets.tagPreset(presetId, [output]);
                        }
                    }
                    resolve(presetId);
                });
        });
    }

    updateTrackPreset(trackNumber) {
        let json = this.getTrackPreset(trackNumber);
        let track = this.tracks[trackNumber];

        presets.updatePresetIpfsHash(track.presetId, json);
    }

    getEffectPreset(trackNumber) {
        let track = this.tracks[trackNumber];

        // get the effects of the track
        let effectsChains = track.effectsChains
            .map(chain => chain.getJson());
        
        let lfo = this.lfos.map(lfo => lfo.getJson());
        let envelopes = this.envelopes.map(env => env.getJson());

        return {
            lfo: lfo,
            envelopes: envelopes,
            trackEffectsChains: effectsChains,
            midiEffects: track.midiEffects.getJson(),
            liveEffects: track.liveEffects.getJson()
        };
    }

    getTrackPreset(trackNumber, isPreset=true) {
        let track = this.tracks[trackNumber];

        // get the send volumes of the track
        let sendVolumes = track.getSendNodes().map(send => send.volume.value);
        
        // get the effects of the track
        let effectsChains = track.effectsChains
            .map(chain => chain.getJson(isPreset));

        let lfo = this.lfos.map(lfo => lfo.getJson(isPreset));
        let envelopes = this.envelopes.map(env => env.getJson());

        return {
            lfos: lfo,
            envelopes: envelopes,
            trackData: track.trackData.getJson(),
            trackParameters: track.getJson(true, isPreset),
            sendVolumes: sendVolumes,
            sendVolumees: sendVolumes,
            trackEffectsChains: effectsChains,
            midiEffects: track.midiEffects.getJson(isPreset),
            liveEffects: track.liveEffects.getJson(isPreset)
        };
   }

    loadOldMixFromJson(json) {
        if (json === undefined) {
            return;
        }

        let deterministicMixesByType = {};
        let deterministicMixesByTypeSubSequence = {};
        for (let type in json.deterministicMixesByType) {
            if (parseInt(type) === 1) {
                deterministicMixesByTypeSubSequence[type] =
                    json.deterministicMixesByType[type];
            } else {
                deterministicMixesByType[type] =
                    json.deterministicMixesByType[type];
            }
        }

        this.mix.loadFromJson({
            ... json,
            deterministicMixesByType: deterministicMixesByType});
        this.currentSubSequence.mix.loadFromJson({
            ... json,
            deterministicMixesByType: deterministicMixesByTypeSubSequence});
    }

    getSamples() {
        let samples = [];
        for (let i in this.subSequences) {
            let subSequence = this.subSequences[i];
            for (let j in subSequence.tracks) {
                let track = subSequence.tracks[j];
                if (track.sample) {
                    samples.push(track.sample.getId());
                }
                if (track.frozenColumns) {
                    for (let col of track.frozenColumns) {
                        for (let sample of col.frozenSamples) {
                            samples.push(sample.getId());
                        }
                    }
                }
            }
        }
        return samples;
    }

    addSampleToSync(sample) {
        this.samplesToSync.push(sample);
    }

    async replaceWithEncryptedSample(sampleId, newSampleId) {
        for (let i in this.subSequences) {
            let subSequence = this.subSequences[i];
            for (let j in subSequence.tracks) {
                let track = subSequence.tracks[j];
                // look at samples
                let samplers = {};
                for (let id in track.samplers) {
                    if (id === sampleId) {
                        samplers[newSampleId] = track.samplers[id];
                    } else {
                        samplers[id] = track.samplers[id];
                    }
                }
                track.samplers = samplers;
                track.soundIds = Object.keys(track.samplers);
            }
        }
    }

    async loadSampleFromSequence(sampleId, sequenceId) {
        let json = await ipfs.getJson(sequenceId);

        let {subSequences} = json;
        let choppedSubSequence = {};
        for (let i in subSequences) {
            let subSequence = subSequences[i];
            for (let j in subSequence.tracksData) {
                j = parseInt(j);
                let trackData = subSequence.tracksData[j];
                if (sampleId in trackData.samplers) {
                    // we found it so use this j to form the actual subSeqeunces;
                    choppedSubSequence = {... subSequence};
                    choppedSubSequence.trackParameters = trackData;
                    choppedSubSequence.sendVolumes = subSequence.sendVolumes[j];
                    choppedSubSequence.trackPatterns = subSequence.tracksPatterns[j];
                    choppedSubSequence.trackEffectsChains = subSequence.tracksEffectsChains[j];
                    choppedSubSequence.trackMidiEffects = subSequence.tracksMidiEffects[j];
                    choppedSubSequence.trackLiveEffects = subSequence.tracksLiveEffects[j];
                    choppedSubSequence.trackData = subSequence.tracksParameters[j];
                    choppedSubSequence.mix = subSequence.mix;
                    choppedSubSequence.tracks = subSequence.tracks[j];

                    let group = subSequence.groups.find(x => x.tracks.indexOf(j) > -1);
                    group.tracks = [0];
                    choppedSubSequence.groups = [group];
                }
            }
        }

        //json.subSequences = [choppedSubSequence];
        // json.bpm = this.bpm;
        // let id = await ipfs.addJson(choppedSubSequence);
        this.loadPresetAsSubSequence({}, choppedSubSequence);
        // delete every track except this one
    }

    setLoadingProgress(id, progress) {
        this.store.dispatch(setSequenceLoadingProgress(id, progress));
    }

    loadPulledEffects(json) {
        if (!json) { return; }
        let effects = [];
        for (let element of json) {
            if (typeof element === "object") {
                let {id, type, instrumentId, x, y, width, height} = element;
                let part = findInstrumentPart(instrumentId || id, type, this);
                if (part) {
                    effects.push({
                        ... element,
                        ... part,
                        x,
                        y,
                        width,
                        height
                    });
                }
            } else {
                let effect = findEffect(element, this);
                if (effect) {
                    effects.push(effect);
                } 
            }
        }
        this.dispatch(setPulledEffects(effects));
    }

    trackIDExists(id, track) {
        return this.subSequences.flatMap(
            m => m.tracks)
            .some(t => t.id === id && t !== track);
    }
}

function getResolution(resolution) {
    let i = resolution.toString().indexOf('t');
    if (i > 0) {
        return new Resolution(parseInt(resolution.slice(0, i)), true);
    } else {
        return new Resolution(parseInt(resolution), false);
    }
}

function isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

export default PersistentSequencer;
